import {
    RESET_SEARCH,
    SET_COMMON_CATEGORIES,
    SET_IS_LOADING_MORE,
    SET_IS_SEARCHING,
    SET_SEARCH_IS_ACTIVE,
    SET_SEARCH_IS_INACTIVE,
    SET_SEARCH_LIMIT,
    SET_SEARCH_OFFSET,
    SET_SEARCH_RESULT,
    SET_SEARCH_TERM,
    SET_SEARCH_FUZZY,
} from 'reducers/actions-types';
import { unionBy } from 'lodash';

export default function scrollReducer(
    state = {
        categories: [],
        categoriesTotal: 0,
        commonCategories: [],
        commonCategoriesTotal: 0,
        isActive: false,
        isLoadingMore: false,
        isSearching: false,
        isFuzzy: true,
        term: '',
        limit: 24,
        offset: 0,
        products: [],
        productsTotal: 0,
    },
    { type, result, isLoadingMore, isSearching, limit, offset, term, isFuzzy }) {
    switch (type) {
        case RESET_SEARCH:
            return Object.assign({}, state, {
                commonCategories: state.commonCategories,
                commonCategoriesTotal: state.commonCategoriesTotal,
                limit: state.limit,
                categories: [],
                categoriesTotal: 0,
                isLoadingMore: false,
                isSearching: false,
                offset: 0,
                products: [],
                productsTotal: 0,
                term: '',
                rotationPersistedTerm: '',
            });
        case SET_SEARCH_IS_ACTIVE:
            return Object.assign({}, state, {
                isActive: true,
            });
        case SET_SEARCH_IS_INACTIVE:
            return Object.assign({}, state, {
                isActive: false,
            });
        case SET_SEARCH_RESULT:
            return Object.assign({}, state, {
                categories: [...result.categories.items],
                categoriesTotal: result.categories.total_hits,
                products: state.isLoadingMore ? unionBy(state.products, result.products.items, 'id') : [...result.products.items],
                productsTotal: result.products.total_hits,
            });
        case SET_COMMON_CATEGORIES:
            return Object.assign({}, state, {
                commonCategories: [...result],
                commonCategoriesTotal: [...result].length,
            });
        case SET_IS_SEARCHING:
            return Object.assign({}, state, {
                isSearching,
            });
        case SET_IS_LOADING_MORE:
            return Object.assign({}, state, {
                isLoadingMore,
            });
        case SET_SEARCH_LIMIT:
            return Object.assign({}, state, {
                limit,
            });
        case SET_SEARCH_TERM:
            return Object.assign({}, state, {
                term,
            });
        case SET_SEARCH_OFFSET:
            return Object.assign({}, state, {
                offset,
            });
        case SET_SEARCH_FUZZY:
            return Object.assign({}, state, {
                isFuzzy,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/search/index.js